import { render } from "./HausStep8b.vue?vue&type=template&id=5dc6ccbe&scoped=true"
import script from "./HausStep8b.vue?vue&type=script&lang=js"
export * from "./HausStep8b.vue?vue&type=script&lang=js"

import "./HausStep8b.vue?vue&type=style&index=0&id=5dc6ccbe&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc6ccbe"]])

export default __exports__